import { GetServerSideProps } from 'next';
import { useIntl } from 'react-intl';

import GuideLayout from '@/components/app/guide/GuideLayoutFacade';
import Layout from '@/components/layout/LayoutWrapper';
import { useGuideInfo } from '@/hooks/app/useGuideInfo';
import { useInitializeGuide } from '@/hooks/app/useInitializeGuide';
import { InitRequest, useGuideState, useProgramState } from '@/hooks/store';
import messages from '@/messages/messages';
import getUrl from '@/utils/getUrl';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const Player = () => {
	const guide = useGuideState();
	const program = useProgramState();
	const { formatMessage } = useIntl();
	const { image } = useGuideInfo(guide!, program!);

	useInitializeGuide(guide!, program!);

	return (
		<Layout
			pageName="player"
			customSeo={{
				url: `${getUrl('www') as string}/player/${guide?.id}`,
				imageUrl: image?.url ? image.url.replace('assets.calm.com/', 'assets.calm.com/400/') : '',
				title: formatMessage(messages.guidePageSeoTitle, {
					title: program?.title,
					narrator: program?.narrator?.name,
				}),
				description: formatMessage(messages.guidePageSeoDescription, { description: program?.description }),
				primaryDescription: formatMessage(messages.guidePageSeoDescription, {
					description: program?.description,
				}),
			}}
		>
			<GuideLayout guide={guide} program={program} />
		</Layout>
	);
};

export default Player;

export const getServerSideProps: GetServerSideProps = async context => {
	const isUATraffic = context.params?.utm_medium !== 'paid';
	const isShareFreeTraffic = context.query?.share_token;
	const promotion = isUATraffic ? '7_day_free_trial' : isShareFreeTraffic ? '30_day_free_trial' : null;
	const initialState = await getInitialServerState(
		context,
		[InitRequest.DEVICE, InitRequest.USER, InitRequest.PRICES],
		{
			promotion,
		},
	);

	const guide = initialState?.guide ?? null;
	const program = initialState?.program ?? null;

	return {
		props: {
			initialState: {
				...initialState,
				theme: {
					webAppLayout: 'player',
				},
			},
		},
		notFound: !guide || !program?.published_at,
	};
};
